export default __webpack_public_path__ + "static/media/KAZ.2d18b6c6.svg";